import { Component, OnInit, SecurityContext, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-post-completion-promo-modal',
  templateUrl: './post-completion-promo-modal.component.html',
  styleUrls: ['./post-completion-promo-modal.component.scss']
})
export class PostCompletionPromoModalComponent implements OnInit {
  modalText: SafeHtml;
  buttonLabel: string = '';
  targetUrl: string = '';

  private currentLang: string = 'pt';

  constructor(
    public dialogRef: MatDialogRef<PostCompletionPromoModalComponent>,
    private router: Router,
    private translate: TranslateService,
    private sanitizer: DomSanitizer,
    @Optional() @Inject(MAT_DIALOG_DATA) private data?: {
      promoConfig?: any;
    }
  ) {
    this.currentLang = this.translate.currentLang || this.translate.defaultLang || 'pt';
    this.modalText = this.sanitizer.bypassSecurityTrustHtml('');
  }

  ngOnInit(): void {
    const config = this.data?.promoConfig;

    if (!config || config.enabled === false) {
      this.dialogRef.close();
      return;
    }

    const textHtml = this.getTranslatedText(config.text);
    const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, textHtml) || '';
    this.modalText = this.sanitizer.bypassSecurityTrustHtml(sanitized);

    this.buttonLabel = this.getTranslatedText(config.buttonLabel)
      || this.translate.instant('JoinThisCase');

    this.targetUrl = typeof config.targetCaseUrl === 'string'
      ? config.targetCaseUrl.trim()
      : '';
  }

  private getTranslatedText(textObj: any): string {
    if (!textObj) return '';

    if (typeof textObj === 'string') {
      return textObj;
    }

    return textObj[this.currentLang] || textObj['pt'] || textObj['en'] || '';
  }

  onCtaClick(): void {
    if (!this.targetUrl) {
      this.dialogRef.close();
      return;
    }

    if (this.isInternalUrl(this.targetUrl)) {
      this.dialogRef.close();
      this.router.navigateByUrl(this.targetUrl);
    } else {
      window.open(this.targetUrl, '_blank', 'noopener');
      this.dialogRef.close();
    }
  }

  private isInternalUrl(url: string): boolean {
    // Rota interna do portal (ex.: "/client/cases/...") — externa começa com http(s)://
    return url.startsWith('/') && !url.startsWith('//');
  }

  close(): void {
    this.dialogRef.close();
  }
}
